import React from "react";
import { ArrowUpRight } from "lucide-react";
import { LINKS } from "@/lib/links";

/**
 * NextSteps — appears at the bottom of the Resources index and every article.
 * Thin gold hairline rule above; two label/line/link options side-by-side.
 * Subtle link treatment — no buttons. Feels like a natural continuation.
 */
export default function NextSteps() {
  return (
    <section data-testid="next-steps" className="py-16 md:py-20">
      <div className="max-w-[860px] mx-auto px-6 md:px-10">
        <span className="block w-full h-px bg-camel/40" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 mt-14">
          {/* Option 1 */}
          <div data-testid="next-step-watch">
            <p className="eyebrow mb-4">Want to See the Full Breakdown?</p>
            <p className="text-nearblack/85 font-light text-[16px] leading-[1.8]">
              Watch the explainer video — a complete walkthrough of how the system works.
            </p>
            <a
              href="/how-it-works"
              data-testid="next-step-watch-link"
              className="mt-5 inline-flex items-center gap-1.5 text-camel hover:text-nearblack transition-colors uppercase tracking-[0.22em] group"
              style={{ fontSize: "11px", fontWeight: 600 }}
            >
              Watch Now
              <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>

          {/* Option 2 */}
          <div data-testid="next-step-book">
            <p className="eyebrow mb-4">Ready to Talk Through Your Situation?</p>
            <p className="text-nearblack/85 font-light text-[16px] leading-[1.8]">
              A Money Clarity Call is a no-pressure conversation about where you are and whether
              this makes sense for you.
            </p>
            <a
              href={LINKS.calendly}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="next-step-book-link"
              className="mt-5 inline-flex items-center gap-1.5 text-camel hover:text-nearblack transition-colors uppercase tracking-[0.22em] group"
              style={{ fontSize: "11px", fontWeight: 600 }}
            >
              Book a Call
              <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
